"use client";

import React from "react";

import { TooltipProvider } from "../ui/tooltip";

import { LogoView } from "./logo-view";

import { NavUser } from "./nav-user";
import { LanguageMenu } from "./language-menu";
import { SessionContext } from "./session-context";

export default function Header() {
  return (
    <header className="bg-muted sticky top-0 z-50 flex h-14 w-full items-center border-b">
      <div className="items- flex h-(--header-height) w-full gap-2">
        <LogoView />

        <div className="flex w-full items-center gap-2 px-5">
          <div className="flex-1" />
          <SessionContext />
          <LanguageMenu />
          <NavUser />
          <TooltipProvider>
            {/* <Tooltip>
              <TooltipTrigger asChild>
                <ModeToggle />
              </TooltipTrigger>
              <TooltipContent>
                <p>모드변경</p>
              </TooltipContent>
            </Tooltip> */}
          </TooltipProvider>
        </div>
        {/* <ThemeSelector /> */}
      </div>
    </header>
  );
}
